// eslint-disable-next-line eag/match-named-export
export const DEFAULT_LOGO_PATH = './assets/images/logo.svg';
